import React, { useState, useContext, useEffect } from "react";
import { Input, BotoneraForm, Select } from "../shared/FormsElements";
import { useRest, Spinner, AuthContext, useAlerta } from "../shared/";
import "../shared/styles/ModernForm.css";

const FormUsuario = (props) => {
  let idBien;

  if (props.match.params.id) {
    idBien = props.match.params.id;
  } else {
    idBien = null;
  }

  const authContext = useContext(AuthContext);
  const {
    usuarioSeleccionado,
    ocultarMensaje,
    registrarUsuario,
    seleccionarUsuario,
    deseleccionarUsuario,
    mensaje,
  } = authContext;

  const [inicio, setInicio] = useState(true);
  const [consultar, setConsultar] = useState(true);

  const [setAlerta, MostrarAlerta] = useAlerta(null);
  const [loading, load] = useRest();
  const [eye, setEye] = useState(false);
  const [alerta, setAlertaLocal] = useState(null);

  const [DatosForm, LeerForm] = useState({
    user_username: "",
    user_type: "",
    user_password: "",
    user_name: "",
    lastname: "",
    email: "",
    codigo_postal: "",
    user_active: "",
  });

  const {
    user_username,
    user_type,
    user_password,
    user_name,
    lastname,
    email,
    codigo_postal,
  } = DatosForm;

  useEffect(() => {
    const cargar = () => {
      if (consultar) {
        setConsultar(false);
        const api = {
          url: "/user",
          type: "get",
          datosJson: null,
          getParams: { id: idBien },
          funcion: seleccionarUsuario,
        };
        /* eslint-disable */
        load(api);
      }
    };

    const alertar = () => {
      if (loading) {
        setAlerta(null);
        setAlertaLocal(null);
      }
      if (inicio) {
        // eslint-disable-next-line
        ocultarMensaje();
        setInicio(null);
        setAlerta(null);
        setAlertaLocal(null);
      } else {
        if (mensaje.msg && !loading) {
          setAlerta({ msg: mensaje.msg, class: mensaje.class });
          setAlertaLocal({ msg: mensaje.msg, class: mensaje.class });
        }
      }
    };

    deseleccionarUsuario();
    if (idBien !== null) {
      cargar();
    }

    alertar();

    if (usuarioSeleccionado !== null) {
      LeerForm(usuarioSeleccionado);
    }
  }, [mensaje, loading, inicio, usuarioSeleccionado, idBien]);

  const sets = [
    {
      label: "Usuario",
      type: "text",
      name: "user_username",
      placeholder: "ingresar en Usuario",
      valor: user_username,
    },
    {
      label: "Password",
      type: "password",
      name: "user_password",
      placeholder: "ingresar el Password",
      valor: user_password,
    },
    {
      label: "Nombre",
      type: "text",
      name: "user_name",
      placeholder: "ingresar el Nombre",
      valor: user_name,
    },
    {
      label: "Apellido",
      type: "text",
      name: "lastname",
      placeholder: "ingresar el Apellido",
      valor: lastname,
    },
    {
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "ingresar el Email",
      valor: email,
    },
    {
      label: "Codigo Postal",
      type: "number",
      name: "codigo_postal",
      placeholder: "ingresar el Codigo Postal",
      valor: codigo_postal,
    },
  ];

  const Insertar = () => {
    if (
      user_username.trim() === "" ||
      user_name.trim() === "" ||
      lastname.trim() === "" ||
      user_type.trim() === "" ||
      user_password.trim() === ""
    ) {
      setAlertaLocal({ msg: "Todos los campos obligatorios deben ser completados", class: "danger" });
      return;
    }

    const api = {
      url: "/users",
      type: "post",
      datosJson: {
        user_username,
        user_type,
        user_password,
        name: user_name,
        lastname,
        email,
        codigo_postal,
      },
      getParams: null,
      funcion: registrarUsuario,
    };

    load(api);
    setTimeout(() => {
      props.history.push("/usuarios");
    }, 2000);
  };

  const Actualizar = () => {
    if (
      user_username.trim() === "" ||
      user_name.trim() === "" ||
      lastname.trim() === "" ||
      user_type.trim() === ""
    ) {
      setAlertaLocal({ msg: "Todos los campos obligatorios deben ser completados", class: "danger" });
      return;
    }

    const api = {
      url: "/users",
      type: "put",
      datosJson: {
        user_id: idBien,
        user_username,
        user_type,
        user_password,
        name: user_name,
        lastname,
        email,
        codigo_postal,
      },
      getParams: null,
      funcion: registrarUsuario,
    };


    
    load(api);
    setTimeout(() => {
      props.history.push("/usuarios");
    }, 2000);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!idBien) {
      Insertar();
    } else {
      Actualizar();
    }
  };

  const onChange = (e) => {
    LeerForm({
      ...DatosForm,
      [e.target.name]: e.target.value,
    });
  };

  const funcionCancelar = () => {
    props.history.push("/usuarios");
  };

  return (
    <div className="modern-form-container">
      <div className="modern-form-header">
        <h1>
          <i className={`bi ${idBien ? 'bi-pencil-square' : 'bi-person-plus-fill'}`}></i>
          {idBien ? "Editar Usuario" : "Crear Nuevo Usuario"}
        </h1>
        <p>{idBien ? "Actualiza la información del usuario" : "Completa los datos para crear un nuevo usuario"}</p>
      </div>

      <div className="modern-form-body">
        <form onSubmit={onSubmit}>
            {alerta && (
              <div className={`modern-form-alert ${alerta.class}`}>
                <i className={`bi ${
                  alerta.class === 'success' ? 'bi-check-circle-fill' :
                  alerta.class === 'danger' ? 'bi-exclamation-circle-fill' :
                  'bi-info-circle-fill'
                }`}></i>
                {alerta.msg}
              </div>
            )}

            {/* Información Básica */}
            <div className="modern-form-section-title">
              <i className="bi bi-person-badge"></i>
              Información Básica
            </div>

            <div className="modern-form-grid">
              <div className="modern-form-group">
                <label className="modern-form-label required">Nombre de Usuario</label>
                <input
                  type="text"
                  name="user_username"
                  className="modern-form-input"
                  placeholder="Ej: jperez"
                  value={user_username}
                  onChange={onChange}
                  autoComplete="off"
                />
                <span className="modern-form-helper">Nombre único para iniciar sesión</span>
              </div>

              <div className="modern-form-group">
                <label className="modern-form-label required">Rol de Usuario</label>
                <select
                  name="user_type"
                  className="modern-form-select"
                  value={user_type}
                  onChange={onChange}
                >
                  <option value="">Seleccionar rol...</option>
                  <option value="Vendedor">Vendedor</option>
                  <option value="Precalificador">Precalificador</option>
                  <option value="Admin">Admin</option>
                  <option value="Cajero">Cajero</option>
                </select>
              </div>
            </div>

            <div className="modern-form-grid">
              <div className="modern-form-group">
                <label className="modern-form-label required">Nombre</label>
                <input
                  type="text"
                  name="user_name"
                  className="modern-form-input"
                  placeholder="Ej: Juan"
                  value={user_name}
                  onChange={onChange}
                  autoComplete="given-name"
                />
              </div>

              <div className="modern-form-group">
                <label className="modern-form-label required">Apellido</label>
                <input
                  type="text"
                  name="lastname"
                  className="modern-form-input"
                  placeholder="Ej: Pérez"
                  value={lastname}
                  onChange={onChange}
                  autoComplete="family-name"
                />
              </div>
            </div>

            {/* Credenciales */}
            <div className="modern-form-section">
              <div className="modern-form-section-title">
                <i className="bi bi-shield-lock"></i>
                Credenciales
              </div>

              <div className="modern-form-grid">
                <div className="modern-form-group modern-form-grid-full">
                  <label className="modern-form-label required">Contraseña</label>
                  <div className="modern-password-group">
                    <input
                      type={eye ? "text" : "password"}
                      name="user_password"
                      className="modern-form-input modern-password-input"
                      placeholder={idBien ? "Dejar en blanco para mantener la actual" : "Crear contraseña segura"}
                      value={user_password}
                      onChange={onChange}
                      autoComplete="new-password"
                    />
                    <button
                      type="button"
                      className="modern-password-toggle"
                      onClick={() => setEye(!eye)}
                    >
                      <i className={`bi ${eye ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
                    </button>
                  </div>
                  <span className="modern-form-helper">
                    {idBien ? "Dejar vacío si no deseas cambiarla" : "Mínimo 8 caracteres recomendados"}
                  </span>
                </div>
              </div>
            </div>

            {/* Información de Contacto */}
            <div className="modern-form-section">
              <div className="modern-form-section-title">
                <i className="bi bi-envelope"></i>
                Información de Contacto
              </div>

              <div className="modern-form-grid">
                <div className="modern-form-group">
                  <label className="modern-form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="modern-form-input"
                    placeholder="correo@ejemplo.com"
                    value={email}
                    onChange={onChange}
                    autoComplete="email"
                  />
                  <span className="modern-form-helper">Opcional</span>
                </div>

                <div className="modern-form-group">
                  <label className="modern-form-label">Código Postal</label>
                  <input
                    type="text"
                    name="codigo_postal"
                    className="modern-form-input"
                    placeholder="Ej: 5000"
                    value={codigo_postal}
                    onChange={onChange}
                    autoComplete="postal-code"
                  />
                  <span className="modern-form-helper">Opcional</span>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="modern-form-actions">
              <button
                type="button"
                className="modern-btn-secondary"
                onClick={funcionCancelar}
                disabled={loading}
              >
                <i className="bi bi-x-lg"></i>
                Cancelar
              </button>
              <button
                type="submit"
                className="modern-btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Guardando...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-lg"></i>
                    {idBien ? "Actualizar Usuario" : "Crear Usuario"}
                  </>
                )}
              </button>
            </div>
          </form>
      </div>
    </div>
  );
};
export default FormUsuario;
